import React from 'react'
import { useTranslation } from 'react-i18next'
import { ShareAltOutlined } from '@ant-design/icons'
import { Tooltip, notification } from 'antd'

import { ROUTE_KEYS } from '@constants'

interface ShareTicketProps {
  ticketId: number
}

const ShareTicket: React.FC<ShareTicketProps> = ({ ticketId }) => {
  const { t } = useTranslation()

  return (
    <Tooltip title={t('share_ticket.send_link')} placement="left">
      <div style={{ marginLeft: '20px' }}>
        <ShareAltOutlined
          onClick={() => {
            navigator.clipboard.writeText(
              `${window.location.origin + ROUTE_KEYS.TICKET}/${ticketId}`,
            )
            notification.success({ message: t('share_ticket.the_link_has_been_copied') })
          }}
        />
      </div>
    </Tooltip>
  )
}

export default ShareTicket
